<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp13',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      title: this.$route.meta.title
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div class="modules-id-13">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-13-content pointer">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-13-${v.id}`"
        class="item"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
      >
        <el-image :src="v.photo | imgPath" alt="avator" class="item-avator" fit="cover" />
        <div class="item-right">
          <div class="name-group">
            <p class="item-name">{{ v.name }}</p>
            <el-image
              v-if="title === '退役军人服务'"
              :src="require('imgs/modules/soldier-logo.png')"
              alt="logo"
              class="soldier-logo"
              fit="cover"
            />
          </div>
          <p class="item-intro h-line-3">{{ v.memo || '' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-13-content {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: 100%;
}
.item {
  width: 455px;
  height: 150px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding-left: 10px;
  box-sizing: border-box;
  .item-avator {
    width: 128px;
    height: 138px;
    border-radius: 5px;
  }
}
.item-right {
  width: 260px;
  margin-left: 30px;
  .name-group {
    width: 260px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-name {
      font-size: 17px;
      font-weight: bold;
      color: #000;
    }
    .soldier-logo {
      width: 145px;
      height: 35px;
    }
  }
}
.item-intro {
  width: 260px;
  font-size: 15px;
  font-weight: 600;
  color: #000;
  line-height: 24px;
  margin-top: 14px;
}
</style>
